import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=a96de338&scoped=true&"
import script from "./CourseList.vue?vue&type=script&lang=js&"
export * from "./CourseList.vue?vue&type=script&lang=js&"
import style0 from "./CourseList.vue?vue&type=style&index=0&id=a96de338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96de338",
  null
  
)

export default component.exports